<template>
    <p
        v-if="showErrorMessage"
        class="text-xs font-normal text-red"
    >
        {{ $t('MAKE_A_SELECTION') }}
    </p>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            categoryName: {
                type: String,
                required: true,
            },
        },

        computed: {
            inErrorState() {
                return this.customizerStore.inErrorState;
            },

            hasBackorderedError() {
                return this.customizerStore.hasBackorderedError;
            },

            selectionWasMade() {
                return this.customizerStore.selectionsMade.includes(this.categoryName);
            },

            cartErrors() {
                return this.customizerStore.cartErrors;
            },

            showErrorMessage() {
                const hasSizeError = this.hasBackorderedError && this.categoryName.includes('Size');

                return (!this.selectionWasMade && this.inErrorState) || hasSizeError;
            },
        },
    };
</script>
